<script>
  export let sub
  import Carousel from '@beyonk/svelte-carousel'
</script>

<div>
  <h2>{sub.title}</h2>
  <div class="status {sub.status}"><p>{sub.status == 'review'? 'in review' : sub.status}</p></div>
  <div class="time">
    submitted: {sub.date}
  </div>
  {#if sub.contents.length > 1}
    <div class="slider-wrap">
      <Carousel perPage={1}>
        {#each sub.contents as item, index}
          {#if item.contentType == 'image'}
            <img class="full" src={item.content} alt="" />
          {:else}
            <video class="full" controls>
              <track kind="captions" />
              <source src={item.content} type="video/mp4">
              Your browser does not support the video tag.
            </video>
          {/if}
        {/each}
      </Carousel>
    </div>
  {:else}
    {#if sub.contents[0].contentType == 'image'}
      <img class="full" src={sub.contents[0].content} alt="" />
    {:else}
      <video class="full" controls>
        <track kind="captions" />
        <source src={sub.contents[0].content} type="video/mp4">
        Your browser does not support the video tag.
      </video>
    {/if}
  {/if}
  <p><b>Your caption:</b></p> 
  <p>{sub.caption}</p>
</div>

<style>
  div {
    text-align: left;
  }
  img, video {
    width: 100%;
    height: auto
  }
  h2 {
    margin-bottom: .1rem;
    margin-top: 0
  }
  .status {
    background-color: #efefef;
    border-radius: .25rem;
    padding: .5rem;
    font-size: .95rem;
    display: inline-block;
  }
  .message {
    background-color: #afecfa;
    border-radius: 1rem;
    padding: .75rem;
    display: flex;
    flex-direction: column;
    gap: .5rem
  }
  .message p {
    margin: 0;
  }
  .time {
    font-size: .8rem;
    color: #777;
    margin-bottom: .5rem;
    
  }
  .status {
    border-radius: 999px;
  }
  .status p {
    margin: 0;
  }
  .submitted {
    background-color: rgb(179, 255, 163)
  }
  .review {
    background-color: rgb(163, 252, 255)
  }
  .approved {
    background-color: rgb(179, 255, 163)
  }
  .denied {
    background-color: rgb(255, 194, 194)
  }
  .posted {
    color: #fff;
    background: radial-gradient(circle at -20% 180%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);
  }
  :global(.carousel ul) {
    background: #00000073;
    border-radius: 999px;
    width: auto !important;
    left: 50%;
    transform: translateX(-50%);
  }
</style>